/* src/components/ReapCta/ReapCta.svelte generated by Svelte v3.48.0 */
import {
	SvelteComponent,
	append_hydration,
	attr,
	children,
	claim_element,
	claim_space,
	claim_text,
	detach,
	element,
	init,
	insert_hydration,
	listen,
	noop,
	prevent_default,
	run_all,
	safe_not_equal,
	set_input_value,
	space,
	text
} from "svelte/internal";

import gql from 'nanographql';
import { onMount } from 'svelte';
import getGraphqlClient from '../../helpers/svelte/utils/getGraphqlClient';

function create_else_block(ctx) {
	let button;
	let t;

	return {
		c() {
			button = element("button");
			t = text("Submit");
			this.h();
		},
		l(nodes) {
			button = claim_element(nodes, "BUTTON", { type: true, class: true });
			var button_nodes = children(button);
			t = claim_text(button_nodes, "Submit");
			button_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button, "type", "submit");
			attr(button, "class", "btn btn-lg btn-primary");
		},
		m(target, anchor) {
			insert_hydration(target, button, anchor);
			append_hydration(button, t);
		},
		d(detaching) {
			if (detaching) detach(button);
		}
	};
}

// (247:6) {#if isProcessing}
function create_if_block(ctx) {
	let button;
	let t;

	return {
		c() {
			button = element("button");
			t = text("Processing");
			this.h();
		},
		l(nodes) {
			button = claim_element(nodes, "BUTTON", { type: true, class: true });
			var button_nodes = children(button);
			t = claim_text(button_nodes, "Processing");
			button_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(button, "type", "submit");
			attr(button, "class", "btn btn-lg btn-primary");
			button.disabled = true;
		},
		m(target, anchor) {
			insert_hydration(target, button, anchor);
			append_hydration(button, t);
		},
		d(detaching) {
			if (detaching) detach(button);
		}
	};
}

function create_fragment(ctx) {
	let div7;
	let h4;
	let t0;
	let t1;
	let form;
	let div6;
	let div0;
	let label0;
	let span0;
	let t2;
	let br0;
	let t3;
	let input0;
	let t4;
	let label1;
	let span1;
	let t5;
	let br1;
	let t6;
	let input1;
	let t7;
	let label2;
	let span2;
	let t8;
	let br2;
	let t9;
	let input2;
	let t10;
	let label3;
	let span3;
	let t11;
	let br3;
	let t12;
	let input3;
	let t13;
	let div2;
	let h50;
	let t14;
	let t15;
	let div1;
	let label4;
	let input4;
	let t16;
	let span4;
	let t17;
	let t18;
	let label5;
	let input5;
	let t19;
	let span5;
	let t20;
	let t21;
	let label6;
	let input6;
	let t22;
	let span6;
	let t23;
	let t24;
	let div3;
	let label7;
	let span7;
	let t25;
	let t26;
	let input7;
	let t27;
	let div5;
	let h51;
	let t28;
	let t29;
	let div4;
	let label8;
	let input8;
	let t30;
	let small0;
	let t31;
	let t32;
	let label9;
	let input9;
	let t33;
	let small1;
	let t34;
	let t35;
	let label10;
	let input10;
	let t36;
	let small2;
	let t37;
	let t38;
	let label11;
	let input11;
	let t39;
	let small3;
	let t40;
	let t41;
	let label12;
	let input12;
	let t42;
	let small4;
	let t43;
	let t44;
	let mounted;
	let dispose;

	function select_block_type(ctx, dirty) {
		if (/*isProcessing*/ ctx[11]) return create_if_block;
		return create_else_block;
	}

	let current_block_type = select_block_type(ctx, -1);
	let if_block = current_block_type(ctx);

	return {
		c() {
			div7 = element("div");
			h4 = element("h4");
			t0 = text("REAP Grant Eligibility Tool");
			t1 = space();
			form = element("form");
			div6 = element("div");
			div0 = element("div");
			label0 = element("label");
			span0 = element("span");
			t2 = text("First Name:");
			br0 = element("br");
			t3 = space();
			input0 = element("input");
			t4 = space();
			label1 = element("label");
			span1 = element("span");
			t5 = text("Last Name:");
			br1 = element("br");
			t6 = space();
			input1 = element("input");
			t7 = space();
			label2 = element("label");
			span2 = element("span");
			t8 = text("Email:");
			br2 = element("br");
			t9 = space();
			input2 = element("input");
			t10 = space();
			label3 = element("label");
			span3 = element("span");
			t11 = text("Phone:");
			br3 = element("br");
			t12 = space();
			input3 = element("input");
			t13 = space();
			div2 = element("div");
			h50 = element("h5");
			t14 = text("Is the entity applying as a small business or an agricultural producer?");
			t15 = space();
			div1 = element("div");
			label4 = element("label");
			input4 = element("input");
			t16 = space();
			span4 = element("span");
			t17 = text("Small Business");
			t18 = space();
			label5 = element("label");
			input5 = element("input");
			t19 = space();
			span5 = element("span");
			t20 = text("Agricultural Producer");
			t21 = space();
			label6 = element("label");
			input6 = element("input");
			t22 = space();
			span6 = element("span");
			t23 = text("Other");
			t24 = space();
			div3 = element("div");
			label7 = element("label");
			span7 = element("span");
			t25 = text("Name of Applying Entity");
			t26 = space();
			input7 = element("input");
			t27 = space();
			div5 = element("div");
			h51 = element("h5");
			t28 = text("Project Location");
			t29 = space();
			div4 = element("div");
			label8 = element("label");
			input8 = element("input");
			t30 = space();
			small0 = element("small");
			t31 = text("Street Address");
			t32 = space();
			label9 = element("label");
			input9 = element("input");
			t33 = space();
			small1 = element("small");
			t34 = text("Street Address Line 2");
			t35 = space();
			label10 = element("label");
			input10 = element("input");
			t36 = space();
			small2 = element("small");
			t37 = text("City");
			t38 = space();
			label11 = element("label");
			input11 = element("input");
			t39 = space();
			small3 = element("small");
			t40 = text("State");
			t41 = space();
			label12 = element("label");
			input12 = element("input");
			t42 = space();
			small4 = element("small");
			t43 = text("Zip Code");
			t44 = space();
			if_block.c();
			this.h();
		},
		l(nodes) {
			div7 = claim_element(nodes, "DIV", { class: true });
			var div7_nodes = children(div7);
			h4 = claim_element(div7_nodes, "H4", { class: true });
			var h4_nodes = children(h4);
			t0 = claim_text(h4_nodes, "REAP Grant Eligibility Tool");
			h4_nodes.forEach(detach);
			t1 = claim_space(div7_nodes);
			form = claim_element(div7_nodes, "FORM", {});
			var form_nodes = children(form);
			div6 = claim_element(form_nodes, "DIV", { class: true });
			var div6_nodes = children(div6);
			div0 = claim_element(div6_nodes, "DIV", { class: true });
			var div0_nodes = children(div0);
			label0 = claim_element(div0_nodes, "LABEL", { class: true });
			var label0_nodes = children(label0);
			span0 = claim_element(label0_nodes, "SPAN", { class: true });
			var span0_nodes = children(span0);
			t2 = claim_text(span0_nodes, "First Name:");
			span0_nodes.forEach(detach);
			br0 = claim_element(label0_nodes, "BR", {});
			t3 = claim_space(label0_nodes);
			input0 = claim_element(label0_nodes, "INPUT", { type: true, class: true });
			label0_nodes.forEach(detach);
			t4 = claim_space(div0_nodes);
			label1 = claim_element(div0_nodes, "LABEL", { class: true });
			var label1_nodes = children(label1);
			span1 = claim_element(label1_nodes, "SPAN", { class: true });
			var span1_nodes = children(span1);
			t5 = claim_text(span1_nodes, "Last Name:");
			span1_nodes.forEach(detach);
			br1 = claim_element(label1_nodes, "BR", {});
			t6 = claim_space(label1_nodes);
			input1 = claim_element(label1_nodes, "INPUT", { type: true, class: true });
			label1_nodes.forEach(detach);
			t7 = claim_space(div0_nodes);
			label2 = claim_element(div0_nodes, "LABEL", { class: true });
			var label2_nodes = children(label2);
			span2 = claim_element(label2_nodes, "SPAN", { class: true });
			var span2_nodes = children(span2);
			t8 = claim_text(span2_nodes, "Email:");
			span2_nodes.forEach(detach);
			br2 = claim_element(label2_nodes, "BR", {});
			t9 = claim_space(label2_nodes);
			input2 = claim_element(label2_nodes, "INPUT", { type: true, class: true });
			label2_nodes.forEach(detach);
			t10 = claim_space(div0_nodes);
			label3 = claim_element(div0_nodes, "LABEL", { class: true });
			var label3_nodes = children(label3);
			span3 = claim_element(label3_nodes, "SPAN", { class: true });
			var span3_nodes = children(span3);
			t11 = claim_text(span3_nodes, "Phone:");
			span3_nodes.forEach(detach);
			br3 = claim_element(label3_nodes, "BR", {});
			t12 = claim_space(label3_nodes);
			input3 = claim_element(label3_nodes, "INPUT", { type: true, class: true });
			label3_nodes.forEach(detach);
			div0_nodes.forEach(detach);
			t13 = claim_space(div6_nodes);
			div2 = claim_element(div6_nodes, "DIV", { class: true });
			var div2_nodes = children(div2);
			h50 = claim_element(div2_nodes, "H5", { class: true });
			var h50_nodes = children(h50);
			t14 = claim_text(h50_nodes, "Is the entity applying as a small business or an agricultural producer?");
			h50_nodes.forEach(detach);
			t15 = claim_space(div2_nodes);
			div1 = claim_element(div2_nodes, "DIV", { class: true });
			var div1_nodes = children(div1);
			label4 = claim_element(div1_nodes, "LABEL", { class: true });
			var label4_nodes = children(label4);
			input4 = claim_element(label4_nodes, "INPUT", { type: true, name: true, class: true });
			t16 = claim_space(label4_nodes);
			span4 = claim_element(label4_nodes, "SPAN", { class: true });
			var span4_nodes = children(span4);
			t17 = claim_text(span4_nodes, "Small Business");
			span4_nodes.forEach(detach);
			label4_nodes.forEach(detach);
			t18 = claim_space(div1_nodes);
			label5 = claim_element(div1_nodes, "LABEL", { class: true });
			var label5_nodes = children(label5);
			input5 = claim_element(label5_nodes, "INPUT", { type: true, name: true, class: true });
			t19 = claim_space(label5_nodes);
			span5 = claim_element(label5_nodes, "SPAN", { class: true });
			var span5_nodes = children(span5);
			t20 = claim_text(span5_nodes, "Agricultural Producer");
			span5_nodes.forEach(detach);
			label5_nodes.forEach(detach);
			t21 = claim_space(div1_nodes);
			label6 = claim_element(div1_nodes, "LABEL", { class: true });
			var label6_nodes = children(label6);
			input6 = claim_element(label6_nodes, "INPUT", { type: true, name: true, class: true });
			t22 = claim_space(label6_nodes);
			span6 = claim_element(label6_nodes, "SPAN", { class: true });
			var span6_nodes = children(span6);
			t23 = claim_text(span6_nodes, "Other");
			span6_nodes.forEach(detach);
			label6_nodes.forEach(detach);
			div1_nodes.forEach(detach);
			div2_nodes.forEach(detach);
			t24 = claim_space(div6_nodes);
			div3 = claim_element(div6_nodes, "DIV", { class: true });
			var div3_nodes = children(div3);
			label7 = claim_element(div3_nodes, "LABEL", { class: true });
			var label7_nodes = children(label7);
			span7 = claim_element(label7_nodes, "SPAN", { class: true });
			var span7_nodes = children(span7);
			t25 = claim_text(span7_nodes, "Name of Applying Entity");
			span7_nodes.forEach(detach);
			t26 = claim_space(label7_nodes);
			input7 = claim_element(label7_nodes, "INPUT", { type: true, class: true });
			label7_nodes.forEach(detach);
			div3_nodes.forEach(detach);
			t27 = claim_space(div6_nodes);
			div5 = claim_element(div6_nodes, "DIV", { class: true });
			var div5_nodes = children(div5);
			h51 = claim_element(div5_nodes, "H5", { class: true });
			var h51_nodes = children(h51);
			t28 = claim_text(h51_nodes, "Project Location");
			h51_nodes.forEach(detach);
			t29 = claim_space(div5_nodes);
			div4 = claim_element(div5_nodes, "DIV", { class: true });
			var div4_nodes = children(div4);
			label8 = claim_element(div4_nodes, "LABEL", { class: true });
			var label8_nodes = children(label8);
			input8 = claim_element(label8_nodes, "INPUT", { type: true, class: true });
			t30 = claim_space(label8_nodes);
			small0 = claim_element(label8_nodes, "SMALL", { class: true });
			var small0_nodes = children(small0);
			t31 = claim_text(small0_nodes, "Street Address");
			small0_nodes.forEach(detach);
			label8_nodes.forEach(detach);
			t32 = claim_space(div4_nodes);
			label9 = claim_element(div4_nodes, "LABEL", { class: true });
			var label9_nodes = children(label9);
			input9 = claim_element(label9_nodes, "INPUT", { type: true, class: true });
			t33 = claim_space(label9_nodes);
			small1 = claim_element(label9_nodes, "SMALL", { class: true });
			var small1_nodes = children(small1);
			t34 = claim_text(small1_nodes, "Street Address Line 2");
			small1_nodes.forEach(detach);
			label9_nodes.forEach(detach);
			t35 = claim_space(div4_nodes);
			label10 = claim_element(div4_nodes, "LABEL", { class: true });
			var label10_nodes = children(label10);
			input10 = claim_element(label10_nodes, "INPUT", { type: true, class: true });
			t36 = claim_space(label10_nodes);
			small2 = claim_element(label10_nodes, "SMALL", { class: true });
			var small2_nodes = children(small2);
			t37 = claim_text(small2_nodes, "City");
			small2_nodes.forEach(detach);
			label10_nodes.forEach(detach);
			t38 = claim_space(div4_nodes);
			label11 = claim_element(div4_nodes, "LABEL", { class: true });
			var label11_nodes = children(label11);
			input11 = claim_element(label11_nodes, "INPUT", { type: true, class: true });
			t39 = claim_space(label11_nodes);
			small3 = claim_element(label11_nodes, "SMALL", { class: true });
			var small3_nodes = children(small3);
			t40 = claim_text(small3_nodes, "State");
			small3_nodes.forEach(detach);
			label11_nodes.forEach(detach);
			t41 = claim_space(div4_nodes);
			label12 = claim_element(div4_nodes, "LABEL", { class: true });
			var label12_nodes = children(label12);
			input12 = claim_element(label12_nodes, "INPUT", { type: true, class: true });
			t42 = claim_space(label12_nodes);
			small4 = claim_element(label12_nodes, "SMALL", { class: true });
			var small4_nodes = children(small4);
			t43 = claim_text(small4_nodes, "Zip Code");
			small4_nodes.forEach(detach);
			label12_nodes.forEach(detach);
			div4_nodes.forEach(detach);
			div5_nodes.forEach(detach);
			t44 = claim_space(div6_nodes);
			if_block.l(div6_nodes);
			div6_nodes.forEach(detach);
			form_nodes.forEach(detach);
			div7_nodes.forEach(detach);
			this.h();
		},
		h() {
			attr(h4, "class", "mb-0");
			attr(span0, "class", "form-label svelte-170ds8e");
			attr(input0, "type", "text");
			attr(input0, "class", "form-control svelte-170ds8e");
			attr(label0, "class", "svelte-170ds8e");
			attr(span1, "class", "form-label svelte-170ds8e");
			attr(input1, "type", "text");
			attr(input1, "class", "form-control svelte-170ds8e");
			attr(label1, "class", "svelte-170ds8e");
			attr(span2, "class", "form-label svelte-170ds8e");
			input2.required = true;
			attr(input2, "type", "email");
			attr(input2, "class", "form-control svelte-170ds8e");
			attr(label2, "class", "svelte-170ds8e");
			attr(span3, "class", "form-label svelte-170ds8e");
			attr(input3, "type", "tel");
			attr(input3, "class", "form-control svelte-170ds8e");
			attr(label3, "class", "svelte-170ds8e");
			attr(div0, "class", "form-group form-inline svelte-170ds8e");
			attr(h50, "class", "svelte-170ds8e");
			input4.__value = "Small Business";
			input4.value = input4.__value;
			attr(input4, "type", "radio");
			attr(input4, "name", "entity");
			attr(input4, "class", "form-check-input svelte-170ds8e");
			/*$$binding_groups*/ ctx[18][0].push(input4);
			attr(span4, "class", "form-label form-check-label svelte-170ds8e");
			attr(label4, "class", "form-check svelte-170ds8e");
			input5.__value = "Agricultural Producer";
			input5.value = input5.__value;
			attr(input5, "type", "radio");
			attr(input5, "name", "entity");
			attr(input5, "class", "form-check-input svelte-170ds8e");
			/*$$binding_groups*/ ctx[18][0].push(input5);
			attr(span5, "class", "form-label form-check-label svelte-170ds8e");
			attr(label5, "class", "form-check svelte-170ds8e");
			input6.__value = "Other";
			input6.value = input6.__value;
			attr(input6, "type", "radio");
			attr(input6, "name", "entity");
			attr(input6, "class", "form-check-input svelte-170ds8e");
			/*$$binding_groups*/ ctx[18][0].push(input6);
			attr(span6, "class", "form-label form-check-label svelte-170ds8e");
			attr(label6, "class", "form-check svelte-170ds8e");
			attr(div1, "class", "input-wrapper svelte-170ds8e");
			attr(div2, "class", "form-group svelte-170ds8e");
			attr(span7, "class", "form-label svelte-170ds8e");
			attr(input7, "type", "text");
			attr(input7, "class", "form-control svelte-170ds8e");
			attr(label7, "class", "svelte-170ds8e");
			attr(div3, "class", "form-group svelte-170ds8e");
			attr(h51, "class", "svelte-170ds8e");
			attr(input8, "type", "text");
			attr(input8, "class", "form-control svelte-170ds8e");
			attr(small0, "class", "svelte-170ds8e");
			attr(label8, "class", "svelte-170ds8e");
			attr(input9, "type", "text");
			attr(input9, "class", "form-control svelte-170ds8e");
			attr(small1, "class", "svelte-170ds8e");
			attr(label9, "class", "svelte-170ds8e");
			attr(input10, "type", "text");
			attr(input10, "class", "form-control svelte-170ds8e");
			attr(small2, "class", "svelte-170ds8e");
			attr(label10, "class", "svelte-170ds8e");
			attr(input11, "type", "text");
			attr(input11, "class", "form-control svelte-170ds8e");
			attr(small3, "class", "svelte-170ds8e");
			attr(label11, "class", "svelte-170ds8e");
			attr(input12, "type", "text");
			attr(input12, "class", "form-control svelte-170ds8e");
			attr(small4, "class", "svelte-170ds8e");
			attr(label12, "class", "svelte-170ds8e");
			attr(div4, "class", "form-inline svelte-170ds8e");
			attr(div5, "class", "form-group svelte-170ds8e");
			attr(div6, "class", "reap-cta-form svelte-170ds8e");
			attr(div7, "class", "reap-cta svelte-170ds8e");
		},
		m(target, anchor) {
			insert_hydration(target, div7, anchor);
			append_hydration(div7, h4);
			append_hydration(h4, t0);
			append_hydration(div7, t1);
			append_hydration(div7, form);
			append_hydration(form, div6);
			append_hydration(div6, div0);
			append_hydration(div0, label0);
			append_hydration(label0, span0);
			append_hydration(span0, t2);
			append_hydration(label0, br0);
			append_hydration(label0, t3);
			append_hydration(label0, input0);
			set_input_value(input0, /*firstName*/ ctx[0]);
			append_hydration(div0, t4);
			append_hydration(div0, label1);
			append_hydration(label1, span1);
			append_hydration(span1, t5);
			append_hydration(label1, br1);
			append_hydration(label1, t6);
			append_hydration(label1, input1);
			set_input_value(input1, /*lastName*/ ctx[1]);
			append_hydration(div0, t7);
			append_hydration(div0, label2);
			append_hydration(label2, span2);
			append_hydration(span2, t8);
			append_hydration(label2, br2);
			append_hydration(label2, t9);
			append_hydration(label2, input2);
			set_input_value(input2, /*email*/ ctx[2]);
			append_hydration(div0, t10);
			append_hydration(div0, label3);
			append_hydration(label3, span3);
			append_hydration(span3, t11);
			append_hydration(label3, br3);
			append_hydration(label3, t12);
			append_hydration(label3, input3);
			set_input_value(input3, /*phone*/ ctx[3]);
			append_hydration(div6, t13);
			append_hydration(div6, div2);
			append_hydration(div2, h50);
			append_hydration(h50, t14);
			append_hydration(div2, t15);
			append_hydration(div2, div1);
			append_hydration(div1, label4);
			append_hydration(label4, input4);
			input4.checked = input4.__value === /*entityType*/ ctx[4];
			append_hydration(label4, t16);
			append_hydration(label4, span4);
			append_hydration(span4, t17);
			append_hydration(div1, t18);
			append_hydration(div1, label5);
			append_hydration(label5, input5);
			input5.checked = input5.__value === /*entityType*/ ctx[4];
			append_hydration(label5, t19);
			append_hydration(label5, span5);
			append_hydration(span5, t20);
			append_hydration(div1, t21);
			append_hydration(div1, label6);
			append_hydration(label6, input6);
			input6.checked = input6.__value === /*entityType*/ ctx[4];
			append_hydration(label6, t22);
			append_hydration(label6, span6);
			append_hydration(span6, t23);
			append_hydration(div6, t24);
			append_hydration(div6, div3);
			append_hydration(div3, label7);
			append_hydration(label7, span7);
			append_hydration(span7, t25);
			append_hydration(label7, t26);
			append_hydration(label7, input7);
			set_input_value(input7, /*entityName*/ ctx[5]);
			append_hydration(div6, t27);
			append_hydration(div6, div5);
			append_hydration(div5, h51);
			append_hydration(h51, t28);
			append_hydration(div5, t29);
			append_hydration(div5, div4);
			append_hydration(div4, label8);
			append_hydration(label8, input8);
			set_input_value(input8, /*streetAddress1*/ ctx[6]);
			append_hydration(label8, t30);
			append_hydration(label8, small0);
			append_hydration(small0, t31);
			append_hydration(div4, t32);
			append_hydration(div4, label9);
			append_hydration(label9, input9);
			set_input_value(input9, /*streetAddress2*/ ctx[7]);
			append_hydration(label9, t33);
			append_hydration(label9, small1);
			append_hydration(small1, t34);
			append_hydration(div4, t35);
			append_hydration(div4, label10);
			append_hydration(label10, input10);
			set_input_value(input10, /*city*/ ctx[8]);
			append_hydration(label10, t36);
			append_hydration(label10, small2);
			append_hydration(small2, t37);
			append_hydration(div4, t38);
			append_hydration(div4, label11);
			append_hydration(label11, input11);
			set_input_value(input11, /*state*/ ctx[9]);
			append_hydration(label11, t39);
			append_hydration(label11, small3);
			append_hydration(small3, t40);
			append_hydration(div4, t41);
			append_hydration(div4, label12);
			append_hydration(label12, input12);
			set_input_value(input12, /*zip*/ ctx[10]);
			append_hydration(label12, t42);
			append_hydration(label12, small4);
			append_hydration(small4, t43);
			append_hydration(div6, t44);
			if_block.m(div6, null);

			if (!mounted) {
				dispose = [
					listen(input0, "input", /*input0_input_handler*/ ctx[13]),
					listen(input1, "input", /*input1_input_handler*/ ctx[14]),
					listen(input2, "input", /*input2_input_handler*/ ctx[15]),
					listen(input3, "input", /*input3_input_handler*/ ctx[16]),
					listen(input4, "change", /*input4_change_handler*/ ctx[17]),
					listen(input5, "change", /*input5_change_handler*/ ctx[19]),
					listen(input6, "change", /*input6_change_handler*/ ctx[20]),
					listen(input7, "input", /*input7_input_handler*/ ctx[21]),
					listen(input8, "input", /*input8_input_handler*/ ctx[22]),
					listen(input9, "input", /*input9_input_handler*/ ctx[23]),
					listen(input10, "input", /*input10_input_handler*/ ctx[24]),
					listen(input11, "input", /*input11_input_handler*/ ctx[25]),
					listen(input12, "input", /*input12_input_handler*/ ctx[26]),
					listen(form, "submit", prevent_default(/*handleSubmit*/ ctx[12]))
				];

				mounted = true;
			}
		},
		p(ctx, [dirty]) {
			if (dirty & /*firstName*/ 1 && input0.value !== /*firstName*/ ctx[0]) {
				set_input_value(input0, /*firstName*/ ctx[0]);
			}

			if (dirty & /*lastName*/ 2 && input1.value !== /*lastName*/ ctx[1]) {
				set_input_value(input1, /*lastName*/ ctx[1]);
			}

			if (dirty & /*email*/ 4 && input2.value !== /*email*/ ctx[2]) {
				set_input_value(input2, /*email*/ ctx[2]);
			}

			if (dirty & /*phone*/ 8) {
				set_input_value(input3, /*phone*/ ctx[3]);
			}

			if (dirty & /*entityType*/ 16) {
				input4.checked = input4.__value === /*entityType*/ ctx[4];
			}

			if (dirty & /*entityType*/ 16) {
				input5.checked = input5.__value === /*entityType*/ ctx[4];
			}

			if (dirty & /*entityType*/ 16) {
				input6.checked = input6.__value === /*entityType*/ ctx[4];
			}

			if (dirty & /*entityName*/ 32 && input7.value !== /*entityName*/ ctx[5]) {
				set_input_value(input7, /*entityName*/ ctx[5]);
			}

			if (dirty & /*streetAddress1*/ 64 && input8.value !== /*streetAddress1*/ ctx[6]) {
				set_input_value(input8, /*streetAddress1*/ ctx[6]);
			}

			if (dirty & /*streetAddress2*/ 128 && input9.value !== /*streetAddress2*/ ctx[7]) {
				set_input_value(input9, /*streetAddress2*/ ctx[7]);
			}

			if (dirty & /*city*/ 256 && input10.value !== /*city*/ ctx[8]) {
				set_input_value(input10, /*city*/ ctx[8]);
			}

			if (dirty & /*state*/ 512 && input11.value !== /*state*/ ctx[9]) {
				set_input_value(input11, /*state*/ ctx[9]);
			}

			if (dirty & /*zip*/ 1024 && input12.value !== /*zip*/ ctx[10]) {
				set_input_value(input12, /*zip*/ ctx[10]);
			}

			if (current_block_type !== (current_block_type = select_block_type(ctx, dirty))) {
				if_block.d(1);
				if_block = current_block_type(ctx);

				if (if_block) {
					if_block.c();
					if_block.m(div6, null);
				}
			}
		},
		i: noop,
		o: noop,
		d(detaching) {
			if (detaching) detach(div7);
			/*$$binding_groups*/ ctx[18][0].splice(/*$$binding_groups*/ ctx[18][0].indexOf(input4), 1);
			/*$$binding_groups*/ ctx[18][0].splice(/*$$binding_groups*/ ctx[18][0].indexOf(input5), 1);
			/*$$binding_groups*/ ctx[18][0].splice(/*$$binding_groups*/ ctx[18][0].indexOf(input6), 1);
			if_block.d();
			mounted = false;
			run_all(dispose);
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	let egKey = '';

	onMount(async () => {
		let egKeyDiv = document.getElementById('eg-key');
		if (egKeyDiv) egKey = egKeyDiv.dataset.egKey;
	});

	const reapForm = gql`
    mutation reapForm(
      $firstName: String
      $lastName: String
      $email: String!
      $phone: String
      $entityType: String
      $entityName: String
      $streetAddress1: String
      $streetAddress2: String
      $city: String
      $state: String
      $zip: String
    ) {
      reapForm(
        input: {
          firstName: $firstName
          lastName: $lastName
          email: $email
          phone: $phone
          entityType: $entityType
          entityName: $entityName
          streetAddress1: $streetAddress1
          streetAddress2: $streetAddress2
          city: $city
          state: $state
          zip: $zip
        }
      ) {
        response: string
      }
    }
  `;

	let firstName = '';
	let lastName = '';
	let email = '';
	let phone = '';
	let entityType = '';
	let entityName = '';
	let streetAddress1 = '';
	let streetAddress2 = '';
	let city = '';
	let state = '';
	let zip = '';
	const graphql = getGraphqlClient();
	let isProcessing = false;

	async function handleSubmit(e) {
		try {
			$$invalidate(11, isProcessing = true);

			let r = await graphql(
				reapForm({
					firstName,
					lastName,
					email,
					phone,
					entityType,
					entityName,
					streetAddress1,
					streetAddress2,
					city,
					state,
					zip
				}),
				{ 'eg-key': egKey }
			);

			if (r.errors) {
				console.error(r.errors);
				$$invalidate(11, isProcessing = false);
				alert('There was an issue. Please try again later or contact us via the contact form at https://findenergy.com/contact/');
			}

			if (r.data && r.data.reapForm && r.data.reapForm.response && r.data.reapForm.response === 'SUCCESS') {
				$$invalidate(11, isProcessing = false);
				alert("Successfully submitted! We'll get back to you ASAP.");
				$$invalidate(0, firstName = '');
				$$invalidate(1, lastName = '');
				$$invalidate(2, email = '');
				$$invalidate(3, phone = '');
				$$invalidate(4, entityType = '');
				$$invalidate(5, entityName = '');
				$$invalidate(6, streetAddress1 = '');
				$$invalidate(7, streetAddress2 = '');
				$$invalidate(8, city = '');
				$$invalidate(9, state = '');
				$$invalidate(10, zip = '');
			}
		} catch(e) {
			$$invalidate(11, isProcessing = false);
			console.error(e);
			alert('There was an issue. Please try again later or contact us via the contact form at https://findenergy.com/contact/');
		}
	}

	const $$binding_groups = [[]];

	function input0_input_handler() {
		firstName = this.value;
		$$invalidate(0, firstName);
	}

	function input1_input_handler() {
		lastName = this.value;
		$$invalidate(1, lastName);
	}

	function input2_input_handler() {
		email = this.value;
		$$invalidate(2, email);
	}

	function input3_input_handler() {
		phone = this.value;
		$$invalidate(3, phone);
	}

	function input4_change_handler() {
		entityType = this.__value;
		$$invalidate(4, entityType);
	}

	function input5_change_handler() {
		entityType = this.__value;
		$$invalidate(4, entityType);
	}

	function input6_change_handler() {
		entityType = this.__value;
		$$invalidate(4, entityType);
	}

	function input7_input_handler() {
		entityName = this.value;
		$$invalidate(5, entityName);
	}

	function input8_input_handler() {
		streetAddress1 = this.value;
		$$invalidate(6, streetAddress1);
	}

	function input9_input_handler() {
		streetAddress2 = this.value;
		$$invalidate(7, streetAddress2);
	}

	function input10_input_handler() {
		city = this.value;
		$$invalidate(8, city);
	}

	function input11_input_handler() {
		state = this.value;
		$$invalidate(9, state);
	}

	function input12_input_handler() {
		zip = this.value;
		$$invalidate(10, zip);
	}

	return [
		firstName,
		lastName,
		email,
		phone,
		entityType,
		entityName,
		streetAddress1,
		streetAddress2,
		city,
		state,
		zip,
		isProcessing,
		handleSubmit,
		input0_input_handler,
		input1_input_handler,
		input2_input_handler,
		input3_input_handler,
		input4_change_handler,
		$$binding_groups,
		input5_change_handler,
		input6_change_handler,
		input7_input_handler,
		input8_input_handler,
		input9_input_handler,
		input10_input_handler,
		input11_input_handler,
		input12_input_handler
	];
}

class ReapCta extends SvelteComponent {
	constructor(options) {
		super();
		init(this, options, instance, create_fragment, safe_not_equal, {});
	}
}

export default ReapCta;